import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import React from 'react';
import { ACTION_SUBJECT_ID } from '@atlaskit/editor-common/analytics';
import { INSERT_BLOCK_SECTION, LINKING_SECTION, OVERFLOW_GROUP, OVERFLOW_GROUP_PRIMARY_TOOLBAR, OVERFLOW_GROUP_PRIMARY_TOOLBAR_RANK, OVERFLOW_GROUP_RANK, OVERFLOW_MENU, OVERFLOW_MENU_PRIMARY_TOOLBAR, OVERFLOW_SECTION, OVERFLOW_SECTION_PRIMARY_TOOLBAR, OVERFLOW_SECTION_PRIMARY_TOOLBAR_RANK, OVERFLOW_SECTION_RANK, PIN_SECTION, TEXT_COLLAPSED_GROUP, TEXT_SECTION, TEXT_SECTION_PRIMARY_TOOLBAR, TEXT_SECTION_COLLAPSED, TEXT_COLLAPSED_MENU, TOOLBAR_RANK, TOOLBARS } from '@atlaskit/editor-common/toolbar';
import { PrimaryToolbar as PrimaryToolbarBase, Show, Toolbar } from '@atlaskit/editor-toolbar';
import { fg } from '@atlaskit/platform-feature-flags';
import { expValEquals } from '@atlaskit/tmp-editor-statsig/exp-val-equals';
import { SELECTION_TOOLBAR_LABEL } from './consts';
import { OverflowMenu } from './OverflowMenu';
import { OverflowSection } from './OverflowSection';
import { PrimaryToolbar } from './PrimaryToolbar';
import { Section } from './Section';
import { TextCollapsedMenu } from './TextCollapsedMenu';
var getInlineTextToolbarComponents = function getInlineTextToolbarComponents() {
  return [{
    type: 'toolbar',
    key: TOOLBARS.INLINE_TEXT_TOOLBAR,
    component: function component(_ref) {
      var children = _ref.children;
      return /*#__PURE__*/React.createElement(Toolbar, {
        label: SELECTION_TOOLBAR_LABEL,
        actionSubjectId: ACTION_SUBJECT_ID.SELECTION_TOOLBAR,
        testId: expValEquals('platform_editor_toolbar_aifc_patch_5', 'isEnabled', true) ? 'editor-floating-toolbar' : undefined
      }, children);
    }
  }];
};
var getPrimaryToolbarComponents = function getPrimaryToolbarComponents() {
  return [{
    type: 'toolbar',
    key: TOOLBARS.PRIMARY_TOOLBAR,
    component: expValEquals('platform_editor_toolbar_aifc_responsive', 'isEnabled', true) ? PrimaryToolbar : function (_ref2) {
      var children = _ref2.children;
      return /*#__PURE__*/React.createElement(PrimaryToolbarBase, {
        label: "Primary Toolbar",
        testId: "primary-toolbar"
      }, children);
    }
  }];
};
export var getToolbarComponents = function getToolbarComponents(contextualFormattingEnabled, api, disableSelectionToolbar) {
  var components = [{
    type: TEXT_SECTION.type,
    key: TEXT_SECTION.key,
    parents: [{
      type: 'toolbar',
      key: TOOLBARS.INLINE_TEXT_TOOLBAR,
      rank: TOOLBAR_RANK[TEXT_SECTION.key]
    }],
    component: function component(_ref3) {
      var children = _ref3.children,
        parents = _ref3.parents;
      if (expValEquals('platform_editor_toolbar_aifc_responsive', 'isEnabled', true)) {
        return /*#__PURE__*/React.createElement(Show, {
          above: "md"
        }, /*#__PURE__*/React.createElement(Section, {
          parents: parents,
          api: api,
          disableSelectionToolbar: disableSelectionToolbar,
          testId: "text-section"
        }, children));
      }
      return /*#__PURE__*/React.createElement(Section, {
        parents: parents,
        api: api,
        disableSelectionToolbar: disableSelectionToolbar,
        testId: "text-section"
      }, children);
    }
  }, {
    type: TEXT_SECTION_PRIMARY_TOOLBAR.type,
    key: TEXT_SECTION_PRIMARY_TOOLBAR.key,
    parents: [{
      type: 'toolbar',
      key: TOOLBARS.PRIMARY_TOOLBAR,
      rank: TOOLBAR_RANK[TEXT_SECTION.key]
    }],
    component: function component(_ref4) {
      var children = _ref4.children,
        parents = _ref4.parents;
      if (expValEquals('platform_editor_toolbar_aifc_responsive', 'isEnabled', true)) {
        return /*#__PURE__*/React.createElement(Show, {
          above: "md"
        }, /*#__PURE__*/React.createElement(Section, {
          parents: parents,
          api: api,
          disableSelectionToolbar: disableSelectionToolbar,
          testId: "text-section"
        }, children));
      }
      return /*#__PURE__*/React.createElement(Section, {
        parents: parents,
        api: api,
        disableSelectionToolbar: disableSelectionToolbar,
        testId: "text-section"
      }, children);
    }
  }].concat(_toConsumableArray(expValEquals('platform_editor_toolbar_aifc_responsive', 'isEnabled', true) ? [{
    type: TEXT_SECTION_COLLAPSED.type,
    key: TEXT_SECTION_COLLAPSED.key,
    parents: [{
      type: 'toolbar',
      key: TOOLBARS.PRIMARY_TOOLBAR,
      rank: TOOLBAR_RANK[TEXT_SECTION_COLLAPSED.key]
    }, expValEquals('platform_editor_toolbar_aifc_responsive', 'isEnabled', true) && {
      type: 'toolbar',
      key: TOOLBARS.INLINE_TEXT_TOOLBAR,
      rank: TOOLBAR_RANK[TEXT_SECTION_COLLAPSED.key]
    }],
    component: function component(_ref5) {
      var children = _ref5.children,
        parents = _ref5.parents;
      return /*#__PURE__*/React.createElement(Show, {
        below: "md"
      }, /*#__PURE__*/React.createElement(Section, {
        parents: parents,
        api: api,
        disableSelectionToolbar: disableSelectionToolbar,
        testId: "text-section"
      }, children));
    }
  }, {
    type: TEXT_COLLAPSED_GROUP.type,
    key: TEXT_COLLAPSED_GROUP.key,
    parents: [{
      type: TEXT_SECTION_COLLAPSED.type,
      key: TEXT_SECTION_COLLAPSED.key,
      rank: 100
    }]
  }, {
    type: TEXT_COLLAPSED_MENU.type,
    key: TEXT_COLLAPSED_MENU.key,
    parents: [{
      type: TEXT_COLLAPSED_GROUP.type,
      key: TEXT_COLLAPSED_GROUP.key,
      rank: 100
    }],
    component: TextCollapsedMenu
  }] : []), [{
    type: INSERT_BLOCK_SECTION.type,
    key: INSERT_BLOCK_SECTION.key,
    parents: [{
      type: 'toolbar',
      key: TOOLBARS.PRIMARY_TOOLBAR,
      rank: TOOLBAR_RANK[INSERT_BLOCK_SECTION.key]
    }],
    component: function component(_ref6) {
      var children = _ref6.children,
        parents = _ref6.parents;
      return /*#__PURE__*/React.createElement(Section, {
        testId: "insert-block-section",
        parents: parents,
        api: api,
        showSeparatorInFullPagePrimaryToolbar: true,
        isSharedSection: false
      }, children);
    }
  }, {
    type: LINKING_SECTION.type,
    key: LINKING_SECTION.key,
    parents: [{
      type: 'toolbar',
      key: TOOLBARS.INLINE_TEXT_TOOLBAR,
      rank: TOOLBAR_RANK[LINKING_SECTION.key]
    }, {
      type: 'toolbar',
      key: TOOLBARS.PRIMARY_TOOLBAR,
      rank: TOOLBAR_RANK[LINKING_SECTION.key]
    }],
    component: function component(_ref7) {
      var children = _ref7.children,
        parents = _ref7.parents;
      return /*#__PURE__*/React.createElement(Section, {
        testId: "link-section",
        parents: parents,
        api: api,
        showSeparatorInFullPagePrimaryToolbar: true
      }, children);
    }
  }, {
    type: OVERFLOW_SECTION.type,
    key: OVERFLOW_SECTION.key,
    parents: [{
      type: 'toolbar',
      key: TOOLBARS.INLINE_TEXT_TOOLBAR,
      rank: TOOLBAR_RANK[OVERFLOW_SECTION.key]
    }]
  }, {
    type: OVERFLOW_GROUP.type,
    key: OVERFLOW_GROUP.key,
    parents: [{
      type: OVERFLOW_SECTION.type,
      key: OVERFLOW_SECTION.key,
      rank: OVERFLOW_SECTION_RANK[OVERFLOW_GROUP.key]
    }]
  }, {
    type: OVERFLOW_MENU.type,
    key: OVERFLOW_MENU.key,
    parents: [{
      type: OVERFLOW_GROUP.type,
      key: OVERFLOW_GROUP.key,
      rank: OVERFLOW_GROUP_RANK[OVERFLOW_MENU.key]
    }],
    component: function component(_ref8) {
      var children = _ref8.children;
      return /*#__PURE__*/React.createElement(OverflowMenu, null, children);
    }
  }, {
    type: PIN_SECTION.type,
    key: PIN_SECTION.key,
    parents: [{
      type: 'toolbar',
      key: TOOLBARS.PRIMARY_TOOLBAR,
      rank: TOOLBAR_RANK[PIN_SECTION.key]
    }]
  }]);
  if (expValEquals('platform_editor_toolbar_migrate_loom', 'isEnabled', true)) {
    components.push({
      type: OVERFLOW_SECTION_PRIMARY_TOOLBAR.type,
      key: OVERFLOW_SECTION_PRIMARY_TOOLBAR.key,
      parents: [{
        type: 'toolbar',
        key: TOOLBARS.PRIMARY_TOOLBAR,
        rank: TOOLBAR_RANK[OVERFLOW_SECTION_PRIMARY_TOOLBAR.key]
      }],
      component: function component(_ref9) {
        var children = _ref9.children;
        return /*#__PURE__*/React.createElement(OverflowSection, null, children);
      }
    }, {
      type: OVERFLOW_GROUP_PRIMARY_TOOLBAR.type,
      key: OVERFLOW_GROUP_PRIMARY_TOOLBAR.key,
      parents: [{
        type: OVERFLOW_SECTION_PRIMARY_TOOLBAR.type,
        key: OVERFLOW_SECTION_PRIMARY_TOOLBAR.key,
        rank: OVERFLOW_SECTION_PRIMARY_TOOLBAR_RANK[OVERFLOW_GROUP_PRIMARY_TOOLBAR.key]
      }]
    }, {
      type: OVERFLOW_MENU_PRIMARY_TOOLBAR.type,
      key: OVERFLOW_MENU_PRIMARY_TOOLBAR.key,
      parents: [{
        type: OVERFLOW_GROUP_PRIMARY_TOOLBAR.type,
        key: OVERFLOW_GROUP_PRIMARY_TOOLBAR.key,
        rank: OVERFLOW_GROUP_PRIMARY_TOOLBAR_RANK[OVERFLOW_MENU_PRIMARY_TOOLBAR.key]
      }],
      component: function component(_ref0) {
        var children = _ref0.children;
        return /*#__PURE__*/React.createElement(OverflowMenu, null, children);
      }
    });
  }
  if (fg('platform_editor_toolbar_aifc_placement_config')) {
    switch (contextualFormattingEnabled) {
      case 'always-inline':
        components.unshift.apply(components, _toConsumableArray(getInlineTextToolbarComponents()));
        break;
      case 'always-pinned':
        components.unshift.apply(components, _toConsumableArray(getPrimaryToolbarComponents()));
        break;
      case 'controlled':
        components.unshift.apply(components, _toConsumableArray(getInlineTextToolbarComponents()));
        components.unshift.apply(components, _toConsumableArray(getPrimaryToolbarComponents()));
        break;
    }
  } else {
    components.unshift.apply(components, _toConsumableArray(getInlineTextToolbarComponents()));
    components.unshift.apply(components, _toConsumableArray(getPrimaryToolbarComponents()));
  }
  return components;
};